import { useContext } from 'react';
import { AlertContext } from '../context/AlertContext';

function useAlert() {
  const { alert, addAlert, removeAlert } = useContext(AlertContext);
  return { alert, addAlert, removeAlert };
}

export default useAlert;